import React from 'react';

const Vue_Local_Components = () => {
  return (
    <div>
      <h1>Vue_Local_Components Component</h1>
      <p>This is the Vue_Local_Components tutorial page.</p>
    </div>
  );
}

export default Vue_Local_Components;
